//#region import
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ProjectContext } from '../../ProjectRequestFrom';
import { Convert, ConvertDateToUnixOrNull, DefaultArrayEmpty, FnAxios, FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { BtnAdd, BtnCancel, BtnClearTable, BtnDraft, BtnEdit, BtnEditTable, BtnExportExcel, BtnSave, BtnSendRequest } from 'components/Button/ButtonAll';
import { APIStatusCode, EnumProjectPlan, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { TextBoxItem } from 'components/Input/TextBox';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled, Chip, Grid, Typography  } from '@mui/material';
import { List as LINQ } from "linqts";
import { parseFloatCheckValue } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import { useLocation } from 'react-router';
import ModalPreview from '../../components/Modal/ModalPreview';
import AccordionPanel from '../../components/AccordionPanel';
import HeaderInput from 'components/Input/HeaderInput';
import WorkPlanDuration from './WorkPlanDuration';
import moment from "moment";
import "../../StyleProject.css";
//#endregion

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const RequestWorkPlan = () => {
    const {
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isChangePanel9,
        setisChangePanel9,
        nProjectSummary,
        setnProjectSummary,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
        setnYearPlanID,
        isModalPreview,
        setisModalPreview,
        setisChangePanel6,
        isChangePlan,
        setisChangePlan,
        nProjectVersionID,
        nLogChangeID,
        ObjCheckSubmitVersion,
        setObjCheckSubmitVersion,
        isChangePanel7,
        setisChangePanel7,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [isError, setisError] = useState(false);
    const [isWeightBtn, setisWeightBtn] = useState(false);
    const [arrDataYearID, setarrDataYearID] = useState([]);
    const [ObjDataAll, setObjDataAll] = useState(null);
    const [lstProjectWorkPlan, setlstProjectWorkPlan] = useState([]);
    const [_dStart, setdStart] = useState(null); //01/01/New + 1
    const [_dEnd, setdEnd] = useState(null); //31/12/New + 1
    const [trigger, setTrigger] = useState(0);
    const [lstSummaryYear, setlstSummaryYear] = useState([]);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nYearID_WorkPlan: null,
        } as any,
    });

    useEffect(() => {
        setisEditSecretary((isModeSecretary === true || nLogChangeID !== null) ? false : isPermission);
    }, [isModeSecretary, nLogChangeID]);

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial();
        // if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    useEffect(() => {
        if (isChangePanel12 === true && nProjectID !== 0) GetFormInitial();
    }, [isChangePanel12]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectWorkPlan, { nProjectID: nProjectID }, (result) => {
            setarrDataYearID(result.lstYearID);
            form.setValue("nYearID_WorkPlan", result.lstYearID.length > 0 ? result.lstYearID[0].value : null);
            // handleGetFormProjectID(result.lstYearID.length > 0 ? result.lstYearID[0].value : 0);
            setdStart(new Date(result.nStartDate));
            setdEnd(new Date(result.nEndDate));
            setisChangePanel12(false);
            onClearField();
        });
    }

    useEffect(() => {
        if (nProjectID !== 0 || (isChangePanel9 === true || isChangePlan === true || isChangePanel7 === true)) {
            let nYear = form.getValues("nYearID_WorkPlan");
            handleGetFormProjectID(nYear);
            setnYearPlanID(Convert.StringToInt(nYear));
        }
    }, [nProjectSummary, isChangePanel9, isChangePlan, isChangePanel7, nProjectID]);

    useEffect(() => {
        let nYear = Convert.StringToIntOrNull(form.getValues("nYearID_WorkPlan"));
        if (nProjectID !== 0 && nYear !== null) {
            handleGetFormProjectID(nYear);
            setnYearPlanID(nYear ?? 0);
            setnProjectPlanID(null);
        }
    }, [form.watch("nYearID_WorkPlan")]);

    useEffect(() => {
        if (nProjectVersionID !== 0) {
            let nYear = form.getValues("nYearID_WorkPlan");
            handleGetFormProjectID(nYear);
        }
    }, [nProjectVersionID]);

    const handleGetFormProjectID = (nYear) => {
        // DialogFn.BlockUI();
        let param = {
            nProjectID: nProjectID,
            nYear: Convert.StringToInt(nYear),
            nProjectSummary: nProjectSummary ?? 0,
            lstnYear: DefaultArrayEmpty((arrDataYearID || []).map(m => Convert.StringToInt(m.value))),
            nProjectVersionID: (nProjectVersionID === 0 ? null : nProjectVersionID),
        };
        // AxiosFn.Get(ApiProject.GetFormProjectID_WorkPlan, param, (result) => {
        //     // DialogFn.UnBlockUI();
        //     setnProjectID(result.objResult.nProjectID);
        //     // setnStatusID(result.objResult.nStatusID);
        //     setisComplete(result.objResult.isComplete);
        //     // setnYear(result.objResult.nYear);
        //     setObjDataAll(result.objResult.ObjDataAll);
        //     setlstProjectWorkPlan(result.objResult.lstProjectWorkPlan);
        //     setisChangePanel9(false);
        //     setlstSummaryYear(result.objResult.lstSummaryYear);
        // });
        AxiosFn.Post(ApiProject.GetFormProjectID_WorkPlan, param, (result) => {
            setnProjectID(result.objResult.nProjectID);
            setisComplete(result.objResult.isComplete);
            setObjDataAll(result.objResult.ObjDataAll);
            setlstProjectWorkPlan(result.objResult.lstProjectWorkPlan);
            setisChangePanel9(false);
            setisChangePlan(false);
            setisChangePanel7(false);
            setlstSummaryYear(result.objResult.lstSummaryYear);
        });
    };

    //#region แผนการปฎิบัติงาน
    const formWorkPlan = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sTargetUnit: null,
            // dStart: null,
            // dEnd: null,
            // nWeight: null,
            // nBudget: null,
        } as any,
    });

    const [arrDuration, setarrDuration] = useState<any>([]);
    const [nProjectPlanID, setnProjectPlanID] = useState(null);
    const [sActivityName, setsActivityName] = useState(null);

    const formDuration = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const onAddDuration = (nActivityID) => {
        setTrigger(trigger + 1);

        let nMax = arrDuration.length > 0 ? Math.max(...arrDuration.map(o => o.nID)) : 0;
        nMax = nMax + 1;

        //#region เก่า
        // let nYear = form.getValues("nYearID_WorkPlan") ? Convert.StringToInt(form.getValues("nYearID_WorkPlan")) : 0;
        // let dDateStart = moment(formDuration.getValues(`sStartMonth_${nMax}`));
        // let dDateEnd = moment(formDuration.getValues(`sEndMonth_${nMax}`));
        // let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(dDateStart.startOf('month').year(nYear)) : null;
        // let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(dDateEnd.endOf('month').year(nYear)) : null;
        // let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "MMMM YYYY", "th");
        // let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "MMMM YYYY", "th");
        // let nMonthStart = parseInt(dDateStart.format("M"));
        // let nMonthEnd = parseInt(dDateEnd.format("M"));
        // let nWeight = parseFloat(formDuration.getValues(`nWeight_${nMax}`));
        // let obj = {
        //     nID: nMax,
        //     nActivityID: ObjDataActivity.nActivityID,
        //     nActivityPlanID: 0,
        //     sTargetUnit: formWorkPlan.getValues("sTargetUnit"),
        //     dStart: dDateStart,
        //     nDateStart: nUnixTimeStart,
        //     dEnd: dDateEnd,
        //     nDateEnd: nUnixTimeEnd,
        //     nMonthStart: nMonthStart,
        //     nMonthEnd: nMonthEnd,
        //     nWeight: nWeight,
        //     // nBudget: null,
        // }
        //#endregion

        let obj = {
            nID: nMax,
            nActivityID: nActivityID,
            nActivityPlanID: 0,
            sTargetUnit: formWorkPlan.getValues("sTargetUnit"),
            dStart: null,
            nDateStart: null,
            dEnd: null,
            nDateEnd: null,
            nMonthStart: null,
            nMonthEnd: null,
            nWeight: null,
            // nBudget: null,
        }
        let arrAdd = [...arrDuration, obj];
        setarrDuration(arrAdd);
    }

    const onDeleteDuration = (nID) => {
        let arrDel = arrDuration.filter(f => f.nID !== nID);
        setarrDuration(arrDel);
    }

    const onEditDuration = (ObjActivity, ObjPlan, nModeID: EnumStatusMode) => {
        setTrigger(trigger + 1);

        setnProjectPlanID(ObjActivity.nProjectPlanID);
        setsActivityName("กิจกรรมที่ " + ObjPlan.nOrder + "." + ObjActivity.nOrder + " " + ObjActivity.sActivity);
        let lstDuration = [{
            nID: 1,
            nActivityID: ObjActivity.nActivityID,
            nActivityPlanID: 0,
            sTargetUnit: ObjActivity.sTargetUnit, //formWorkPlan.getValues("sTargetUnit"), //เปลี่ยนเพราะมีการบันทึกที่เดียวกันในทุกปีๆ 1 กิจกรรม มีได้แค่ 1 Target Unit
            dStart: null,
            nDateStart: null,
            dEnd: null,
            nDateEnd: null,
            nMonthStart: null,
            nMonthEnd: null,
            nWeight: null,
            // nBudget: null,
        }]

        let arrDataWorkPlan = [];
        let sTargetUnit = ObjActivity.sTargetUnit; //null; //เปลี่ยนเพราะมีการบันทึกที่เดียวกันในทุกปีๆ 1 กิจกรรม มีได้แค่ 1 Target Unit
        (ObjActivity.lstWorkPlanDate || []).forEach(iWorkPlan => {
            arrDataWorkPlan.push({
                nID: iWorkPlan.nID,
                nActivityID: iWorkPlan.nActivityID,
                nActivityPlanID: iWorkPlan.nActivityPlanID,
                sTargetUnit: ObjActivity.sTargetUnit, //iWorkPlan.sTargetUnit, //เปลี่ยนเพราะมีการบันทึกที่เดียวกันในทุกปีๆ 1 กิจกรรม มีได้แค่ 1 Target Unit
                dStart: moment(iWorkPlan.dStart), //moment(iWorkPlan.dStart).year(new Date().getFullYear()), //มีปัญหาที่ Date ไม่ขึ้นให้เลือกของปีที่เราต้องการเริ่ม มันมองแต่ปัจุบันเลยต้องใช้วิธีนี้ //moment(iWorkPlan.dStart), ควรเป็นแบบนี้
                nDateStart: iWorkPlan.nDateStart,
                dEnd: moment(iWorkPlan.dEnd), //moment(iWorkPlan.dEnd).year(new Date().getFullYear()), //moment(iWorkPlan.dEnd),
                nDateEnd: iWorkPlan.nDateEnd,
                nMonthStart: iWorkPlan.nMonthStart,
                nMonthEnd: iWorkPlan.nMonthEnd,
                nWeight: iWorkPlan.nWeight,
                // nBudget: iWorkPlan.nBudget,
            });

            // sTargetUnit = iWorkPlan.sTargetUnit; //เปลี่ยนเพราะมีการบันทึกที่เดียวกันในทุกปีๆ 1 กิจกรรม มีได้แค่ 1 Target Unit << ปิด
            formDuration.setValue(`sStartMonth_${iWorkPlan.nID}`, moment(iWorkPlan.nDateStart).year(new Date().getFullYear()));
            formDuration.setValue(`sEndMonth_${iWorkPlan.nID}`, moment(iWorkPlan.nDateEnd).year(new Date().getFullYear()));
            formDuration.setValue(`nWeight_${iWorkPlan.nID}`, iWorkPlan.nWeight);
        });
        formWorkPlan.setValue("sTargetUnit", sTargetUnit);
        setarrDuration((ObjActivity.lstWorkPlanDate || []).length > 0 ? arrDataWorkPlan : lstDuration);

        document.getElementById("myDivWorkPlan").scrollIntoView({ behavior: "smooth" });
    }

    const onClearDuration = () => {
        Object.keys(formDuration.getValues()).forEach((key) => {
            formDuration.setValue(key, null);
            formDuration.clearErrors(key);
        });
    };

    const onClear = (ObjDataActivity, ObjDataWorkPlan, nModeID: EnumStatusMode) => {
        setnProjectPlanID(null);
        setarrDuration([]);

        //#region UpDate
        ObjDataActivity.nM1 = null;
        ObjDataActivity.nM2 = null;
        ObjDataActivity.nM3 = null;
        ObjDataActivity.nM4 = null;
        ObjDataActivity.nM5 = null;
        ObjDataActivity.nM6 = null;
        ObjDataActivity.nM7 = null;
        ObjDataActivity.nM8 = null;
        ObjDataActivity.nM9 = null;
        ObjDataActivity.nM10 = null;
        ObjDataActivity.nM11 = null;
        ObjDataActivity.nM12 = null;
        // ObjDataActivity.sTargetUnit = null;
        ObjDataActivity.lstWorkPlanDate = [];
        // ObjDataActivity.nWeightActivityAll = null;
        // ObjDataActivity.isUpDate = false;
        //เปลี่ยน เงื่อนไข ค่ารวมทั้งกิจกรรม ทุกปี 
        ObjDataActivity.nWeightActivityAll = ObjDataActivity.nWeightActivityYearAll !== null ? 0 : null; //ค่ารวมทั้งกิจกรรม
        ObjDataActivity.isUpDate = ObjDataActivity.nWeightActivityYearAll !== null; //ObjDataActivity.nWeightActivityYearAll !== null ? true : false
        if (ObjDataActivity.nWeightActivityYearAll === null) ObjDataActivity.sTargetUnit = null; //ถ้ามีข้อมูลของปีอื่นอยู่จะไม่ให้ null

        // ObjDataWorkPlan.isSuccess = false;
        // ObjDataWorkPlan.nM1All = ;
        // ObjDataWorkPlan.nM2All = ;
        // ObjDataWorkPlan.nM3All = ;
        // ObjDataWorkPlan.nM4All = ;
        // ObjDataWorkPlan.nM5All = ;
        // ObjDataWorkPlan.nM6All = ;
        // ObjDataWorkPlan.nM7All = ;
        // ObjDataWorkPlan.nM8All = ;
        // ObjDataWorkPlan.nM9All = ;
        // ObjDataWorkPlan.nM10All = ;
        // ObjDataWorkPlan.nM11All = ;
        // ObjDataWorkPlan.nM12All = ;
        // ObjDataWorkPlan.nQuarter1All = ;
        // ObjDataWorkPlan.nQuarter2All = ;
        // ObjDataWorkPlan.nQuarter3All = ;
        // ObjDataWorkPlan.nQuarter4All = ;
        // ObjDataWorkPlan.nWeightAll = ;

        [...lstProjectWorkPlan].filter(w => w.nProjectPlanID === ObjDataWorkPlan.nProjectPlanID).forEach(iPlan => {
            iPlan.nWeightAll = new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s => s.nWeightActivityAll);
            // iPlan.nM1All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM1) || 0).reduce((a, b) => a + b, 0); //new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s=> s.nM1); 
            // iPlan.nM2All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM2) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM3All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM3) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM4All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM4) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM5All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM5) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM6All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM6) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM7All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM7) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM8All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM8) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM9All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM9) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM10All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM10) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM11All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM11) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nM12All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM12) || 0).reduce((a, b) => a + b, 0);
            // iPlan.nQuarter1All = parseFloat((iPlan.nM1All ?? 0) + (iPlan.nM2All ?? 0) + (iPlan.nM3All ?? 0));
            // iPlan.nQuarter2All = parseFloat((iPlan.nM4All ?? 0) + (iPlan.nM5All ?? 0) + (iPlan.nM6All ?? 0));
            // iPlan.nQuarter3All = parseFloat((iPlan.nM7All ?? 0) + (iPlan.nM8All ?? 0) + (iPlan.nM9All ?? 0));
            // iPlan.nQuarter4All = parseFloat((iPlan.nM10All ?? 0) + (iPlan.nM11All ?? 0) + (iPlan.nM12All ?? 0));
            // let nCountPlanActivity = new LINQ<any>(iPlan.lstProjectPlanActivity).Where(s=> s.isUpDate === true).Count(); 
            // iPlan.isSuccess = (iPlan.lstProjectPlanActivity || []).length === nCountPlanActivity ? true : false;

            iPlan.nM1All = iPlan.lstProjectPlanActivity.filter(f => f.nM1 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM1 !== null).Sum(s => s.nM1) : null;
            iPlan.nM2All = iPlan.lstProjectPlanActivity.filter(f => f.nM2 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM2 !== null).Sum(s => s.nM2) : null;
            iPlan.nM3All = iPlan.lstProjectPlanActivity.filter(f => f.nM3 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM3 !== null).Sum(s => s.nM3) : null;
            iPlan.nM4All = iPlan.lstProjectPlanActivity.filter(f => f.nM4 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM4 !== null).Sum(s => s.nM4) : null;
            iPlan.nM5All = iPlan.lstProjectPlanActivity.filter(f => f.nM5 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM5 !== null).Sum(s => s.nM5) : null;
            iPlan.nM6All = iPlan.lstProjectPlanActivity.filter(f => f.nM6 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM6 !== null).Sum(s => s.nM6) : null;
            iPlan.nM7All = iPlan.lstProjectPlanActivity.filter(f => f.nM7 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM7 !== null).Sum(s => s.nM7) : null;
            iPlan.nM8All = iPlan.lstProjectPlanActivity.filter(f => f.nM8 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM8 !== null).Sum(s => s.nM8) : null;
            iPlan.nM9All = iPlan.lstProjectPlanActivity.filter(f => f.nM9 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM9 !== null).Sum(s => s.nM9) : null;
            iPlan.nM10All = iPlan.lstProjectPlanActivity.filter(f => f.nM10 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM10 !== null).Sum(s => s.nM10) : null;
            iPlan.nM11All = iPlan.lstProjectPlanActivity.filter(f => f.nM11 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM11 !== null).Sum(s => s.nM11) : null;
            iPlan.nM12All = iPlan.lstProjectPlanActivity.filter(f => f.nM12 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM12 !== null).Sum(s => s.nM12) : null;
            let nQ1 = null;
            let nQ2 = null;
            let nQ3 = null;
            let nQ4 = null;
            if (iPlan.nM1All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM1All;
            if (iPlan.nM2All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM2All;
            if (iPlan.nM3All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM3All;
            if (iPlan.nM4All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM4All;
            if (iPlan.nM5All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM5All;
            if (iPlan.nM6All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM6All;
            if (iPlan.nM7All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM7All;
            if (iPlan.nM8All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM8All;
            if (iPlan.nM9All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM9All;
            if (iPlan.nM10All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM10All;
            if (iPlan.nM11All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM11All;
            if (iPlan.nM12All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM12All;
            iPlan.nQuarter1All = nQ1;
            iPlan.nQuarter2All = nQ2;
            iPlan.nQuarter3All = nQ3;
            iPlan.nQuarter4All = nQ4;

            let nCountPlanActivity = new LINQ<any>(iPlan.lstProjectPlanActivity).Where(s => s.isUpDate === true).Count();
            iPlan.isSuccess = (iPlan.lstProjectPlanActivity || []).length === nCountPlanActivity ? true : false;
        });
        //#endregion

        // //#region Weight แบบทุกกิจกรรม
        // let _nWeightAll = 0;
        // let clone = [...lstProjectWorkPlan];
        // let lstData = [].concat(...clone.map(m => m.lstProjectPlanActivity)).filter(f => f.nActivityID !== ObjDataActivity.nActivityID);
        // _nWeightAll = lstData.map(m => parseInt(m.nWeightActivityAll) || 0).reduce((a, b) => a + b, 0);
        // setnWeight(_nWeightAll);  //รวมทั้งหมดโครงการ
        // //#endregion

        onClearDuration();
    }

    const SetValueSum = (arr) => {
        let v = (arr || []).filter(f => f !== undefined && f !== null);
        if (v.length > 0) {
            let val = new LINQ<any>(v).Sum(s => s);
            return parseFloatCheckValue(val);
        } else {
            return null;
        }
    }

    const CallTableWorkPlan = useCallback(() => {
        //#region arrSum nWeightAll
        let arrSumnWeightAll = [];
        let arrSumnM1All = [];
        let arrSumnM2All = [];
        let arrSumnM3All = [];
        let arrSumnM4All = [];
        let arrSumnM5All = [];
        let arrSumnM6All = [];
        let arrSumnM7All = [];
        let arrSumnM8All = [];
        let arrSumnM9All = [];
        let arrSumnM10All = [];
        let arrSumnM11All = [];
        let arrSumnM12All = [];
        let arrSumnQuarter1All = [];
        let arrSumnQuarter2All = [];
        let arrSumnQuarter3All = [];
        let arrSumnQuarter4All = [];
        //#endregion

        return (
            <TableContainer id='table-WorkPlan' component={Paper}>
                <Table sx={{ minWidth: 500 }}>
                    <TableHead>
                        <TableRow>
                            {((isPermission && isModeSecretary !== true) || isEditSecretary === true) && <TableCell component="th" padding='none' style={{ minWidth: '95px', width: '95px' }} rowSpan={3}></TableCell>}
                            <TableCell component="th" padding='none' style={{ minWidth: '210px', width: '210px' }} rowSpan={3}>แผนงาน/กิจกรรม</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} rowSpan={3}>เป้าหมาย/ปริมาณงาน (หน่วยนับ)</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '80px', width: '80px' }} rowSpan={3}>ค่าน้ำหนัก (ร้อยละ)</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} colSpan={12}>ระยะเวลาปฎิบัติงาน</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#fbfbfb', color: '#3e3e3e', minWidth: '20px', width: '20px' }} colSpan={3}>{ParseHtml("ไตรมาส 1" + (form.getValues("nYearID_WorkPlan") ? "<br/> ปี บัญชี " + Convert.StringToInt(form.getValues("nYearID_WorkPlan") + 543) : ""))}</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#fbfbfb', color: '#3e3e3e', minWidth: '20px', width: '20px' }} colSpan={3}>{ParseHtml("ไตรมาส 2" + (form.getValues("nYearID_WorkPlan") ? "<br/> ปี บัญชี " + Convert.StringToInt(form.getValues("nYearID_WorkPlan") + 543) : ""))}</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#fbfbfb', color: '#3e3e3e', minWidth: '20px', width: '20px' }} colSpan={3}>{ParseHtml("ไตรมาส 3" + (form.getValues("nYearID_WorkPlan") ? "<br/> ปี บัญชี " + Convert.StringToInt(form.getValues("nYearID_WorkPlan") + 543) : ""))}</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#fbfbfb', color: '#3e3e3e', minWidth: '20px', width: '20px' }} colSpan={3}>{ParseHtml("ไตรมาส 4" + (form.getValues("nYearID_WorkPlan") ? "<br/> ปี บัญชี " + Convert.StringToInt(form.getValues("nYearID_WorkPlan") + 543) : ""))}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ม.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ก.พ.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>มี.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>เม.ย.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>พ.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>มิ.ย.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ก.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ส.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ก.ย.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ต.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>พ.ย.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ธ.ค.</TableCell>
                        </TableRow>
                    </TableHead>
                    {lstProjectWorkPlan.length > 0 ?
                        <TableBody>
                            {lstProjectWorkPlan.map((iWorkPlan, index) => {
                                //#region arrSum nWeightAll
                                // if (parseFloatCheckValue(iWorkPlan.nWeightAll)) arrSumnWeightAll.push(iWorkPlan.nWeightAll);

                                if (iWorkPlan.nWeightAll !== null) arrSumnWeightAll.push(iWorkPlan.nWeightAll); //ค่ารวมทุกกิจกรรม
                                if (iWorkPlan.nWeightYearAll !== null) arrSumnWeightAll.push(iWorkPlan.nWeightYearAll); //ค่ารวมทุกกิจกรรม ทุกปี

                                if (iWorkPlan.nM1All !== null) arrSumnM1All.push(iWorkPlan.nM1All);
                                if (iWorkPlan.nM2All !== null) arrSumnM2All.push(iWorkPlan.nM2All);
                                if (iWorkPlan.nM3All !== null) arrSumnM3All.push(iWorkPlan.nM3All);
                                if (iWorkPlan.nM4All !== null) arrSumnM4All.push(iWorkPlan.nM4All);
                                if (iWorkPlan.nM5All !== null) arrSumnM5All.push(iWorkPlan.nM5All);
                                if (iWorkPlan.nM6All !== null) arrSumnM6All.push(iWorkPlan.nM6All);
                                if (iWorkPlan.nM7All !== null) arrSumnM7All.push(iWorkPlan.nM7All);
                                if (iWorkPlan.nM8All !== null) arrSumnM8All.push(iWorkPlan.nM8All);
                                if (iWorkPlan.nM9All !== null) arrSumnM9All.push(iWorkPlan.nM9All);
                                if (iWorkPlan.nM10All !== null) arrSumnM10All.push(iWorkPlan.nM10All);
                                if (iWorkPlan.nM11All !== null) arrSumnM11All.push(iWorkPlan.nM11All);
                                if (iWorkPlan.nM12All !== null) arrSumnM12All.push(iWorkPlan.nM12All);
                                if (iWorkPlan.nQuarter1All !== null) arrSumnQuarter1All.push(iWorkPlan.nQuarter1All);
                                if (iWorkPlan.nQuarter2All !== null) arrSumnQuarter2All.push(iWorkPlan.nQuarter2All);
                                if (iWorkPlan.nQuarter3All !== null) arrSumnQuarter3All.push(iWorkPlan.nQuarter3All);
                                if (iWorkPlan.nQuarter4All !== null) arrSumnQuarter4All.push(iWorkPlan.nQuarter4All);
                                //#endregion

                                return (
                                    <>
                                        <TableRow key={`sID_WorkPlan_Plan_${iWorkPlan.nProjectPlanID}`}>
                                            <TableCell className='bg-color' colSpan={(!isPermission || isEditSecretary === false) ? 15 : 16} align="left">{"แผนงานที่ " + iWorkPlan.nOrder + ". " + iWorkPlan.sPlan}</TableCell>
                                        </TableRow>
                                        {iWorkPlan.lstProjectPlanActivity.filter(f => f.nProjectPlanID === iWorkPlan.nProjectPlanID).map((iActivity) => {
                                            return (
                                                <TableRow key={`sID_WorkPlan_Activity_${iActivity.nActivityID}`} sx={{ height: '50px', }}>
                                                    {!iActivity.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                        <TableCell align="center">
                                                            <Grid item xs={12} md={12} container spacing={1} key={`Btn_${iActivity.nActivityID}`}>
                                                                <Grid item>
                                                                    <BtnEditTable
                                                                        key={"btnEdit_WorkPlan_Activity_" + iActivity.nActivityID}
                                                                        id={"btnEdit_WorkPlan_Activity_" + iActivity.nActivityID}
                                                                        onClick={() => { onClearField(); onEditDuration(iActivity, iWorkPlan, EnumStatusMode.Edit) }}
                                                                        IsDisabled={!isPermission || isEditSecretary === false}
                                                                        IsCircleWithOutText={true}
                                                                    />
                                                                </Grid>
                                                                <Grid item>
                                                                    <BtnClearTable
                                                                        key={"btnDelete_WorkPlan_Activity_" + iActivity.nActivityID}
                                                                        id={"btnDelete_WorkPlan_Activity_" + iActivity.nActivityID}
                                                                        onClick={() => onClear(iActivity, iWorkPlan, EnumStatusMode.Clear)}
                                                                        IsDisabled={!isPermission || isEditSecretary === false}
                                                                        IsCircleWithOutText={true}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            {/* :
                                                                <BtnViewTable
                                                                    key={"btnPreview_WorkPlan_Activity_" + iActivity.nActivityID}
                                                                    id={"btnPreview_WorkPlan_Activity_" + iActivity.nActivityID}
                                                                    onClick={() => {onClearField(); onEditDuration(iActivity, EnumStatusMode.View)} }
                                                                    // IsDisabled={!isPermission || isEditSecretary === false}
                                                                    IsCircleWithOutText={true}
                                                                /> */}
                                                        </TableCell>
                                                    }
                                                    <TableCell align="left">
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{ParseHtml("กิจกรรมที่ " + iWorkPlan.nOrder + "." + iActivity.nOrder + " " + iActivity.sActivity)}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.sTargetUnit}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{formatNumber(iActivity.nWeightActivityYearAll != null ? (iActivity.nWeightActivityAll + iActivity.nWeightActivityYearAll) : iActivity.nWeightActivityAll, 0)}</Typography>
                                                        </Grid>
                                                    </TableCell>

                                                    {/* ไตรมาส 1 */}
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM1 !== null ? '#0056b3' : ''), color: (iActivity.nM1 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM1}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM2 !== null ? '#0056b3' : ''), color: (iActivity.nM2 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM2}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM3 !== null ? '#0056b3' : ''), color: (iActivity.nM3 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM3}</Typography>
                                                        </Grid>
                                                    </TableCell>

                                                    {/* ไตรมาส 2 */}
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM4 !== null ? '#0056b3' : ''), color: (iActivity.nM4 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM4}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM5 !== null ? '#0056b3' : ''), color: (iActivity.nM5 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM5}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM6 !== null ? '#0056b3' : ''), color: (iActivity.nM6 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM6}</Typography>
                                                        </Grid>
                                                    </TableCell>

                                                    {/* ไตรมาส 3 */}
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM7 !== null ? '#0056b3' : ''), color: (iActivity.nM7 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM7}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM8 !== null ? '#0056b3' : ''), color: (iActivity.nM8 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM8}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM9 !== null ? '#0056b3' : ''), color: (iActivity.nM9 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM9}</Typography>
                                                        </Grid>
                                                    </TableCell>

                                                    {/* ไตรมาส 4 */}
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM10 !== null ? '#0056b3' : ''), color: (iActivity.nM10 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM10}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM11 !== null ? '#0056b3' : ''), color: (iActivity.nM11 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM11}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ backgroundColor: (iActivity.nM12 !== null ? '#0056b3' : ''), color: (iActivity.nM12 !== null ? 'white' : '') }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iActivity.nM12}</Typography>
                                                        </Grid>
                                                    </TableCell>

                                                </TableRow>
                                            )
                                        })}
                                    </>
                                )
                            })}
                            {arrSumnWeightAll.length > 0 &&
                                <>
                                    <TableRow key={`sID_WorkPlan_Sum_`}>
                                        <TableCell className='bg-color1' colSpan={(!isPermission || isEditSecretary === false) ? 2 : 3} align="center" style={{ backgroundColor: '#fbfbfb', }}></TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnWeightAll), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM1All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM2All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM3All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM4All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM5All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM6All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM7All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM8All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM9All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM10All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM11All), 0)}</TableCell>
                                        <TableCell className='bg-color1' align="center">{formatNumber(SetValueSum(arrSumnM12All), 0)}</TableCell>
                                    </TableRow>
                                    <TableRow key={`sID_WorkPlan_SumAll`}>
                                        <TableCell className='bg-color1' colSpan={(!isPermission || isEditSecretary === false) ? 2 : 3} align="center" style={{ backgroundColor: '#fbfbfb', }}></TableCell>
                                        <TableCell className='bg-color1' align="center">{GetSumWeightAll(arrSumnWeightAll)}</TableCell>
                                        <TableCell className='bg-color1' colSpan={3} align="center">{formatNumber(SetValueSum(arrSumnQuarter1All), 0)}</TableCell>
                                        <TableCell className='bg-color1' colSpan={3} align="center">{formatNumber(SetValueSum(arrSumnQuarter2All), 0)}</TableCell>
                                        <TableCell className='bg-color1' colSpan={3} align="center">{formatNumber(SetValueSum(arrSumnQuarter3All), 0)}</TableCell>
                                        <TableCell className='bg-color1' colSpan={3} align="center">{formatNumber(SetValueSum(arrSumnQuarter4All), 0)}</TableCell>
                                    </TableRow>
                                </>
                            }
                        </TableBody>
                        :
                        <TableRow key={"r-no-data"} >
                            <TableCell align="center" colSpan={(!isPermission || isEditSecretary === false) ? 15 : 16}>ไม่พบข้อมูล</TableCell>
                        </TableRow>
                    }
                </Table>
            </TableContainer>
        );
    }, [lstProjectWorkPlan, isEditSecretary]);

    const [nWeight, setnWeight] = useState(null);
    const GetSumWeightAll = (arrSumnWeightAll) => {
        let nSumWeightAll = SetValueSum(arrSumnWeightAll);
        setnWeight(nSumWeightAll);
        return formatNumber(nSumWeightAll, 0);
    }

    useEffect(() => {
        if (nWeight > 100) {
            setisError(true);
            setisWeightBtn(false);
        } else {
            setisError(false);

            if (nWeight === 100 && arrDataYearID.length === 1) { //ถ้ามีปีเดียวต้องเท่ากับ 100 ถึงกดปุ่มพร้อมส่งได้
                setisWeightBtn(true);
            } else {
                // if (arrDataYearID.length > 1) { //ถ้ามีหลายปีจะต้องเอาทุกปีมาพวกกันก่อน
                //     let nYear = form.getValues("nYearID_WorkPlan") ? Convert.StringToInt(form.getValues("nYearID_WorkPlan")) : 0;
                //     let nWeightAllYear = new LINQ<any>(lstSummaryYear).Where(w=> w.nYear !== nYear).Sum(s=> s.nWeightAll);
                //     let _nWeightAllYear = nWeight + nWeightAllYear;
                //     // // setisWeightBtn(_nWeightAllYear === 100 ? true : false);
                //     //จะต้องยังไม่ดัน ว่ารายปี ยังไม่ถึง 100 ห้ามบันทึก จะต้อง กดบันทึกได้ และ ค่อยเอาทุกปีมาเช็ค
                //     setisWeightBtn(true);
                // } else {
                //     setisWeightBtn(nWeight === 100 ? true : false);
                // }

                setisWeightBtn(nWeight === 100 ? true : false); //เปลี่ยนรูปแบบใหม่ ให้มีการรวมค่าน้ำหนักของทุกปีทุกกิจกกรมมารวมกันเลย
            }
        }
    }, [nWeight]);

    const onAddWorkPlan = () => {
        let objDuration = formDuration.getValues();
        if (Object.values(objDuration).filter(f => f == null).length > 0) {
            document.getElementById("AddDuration").click();
        } else {
            let _lstDuration = arrDuration ?? [];
            let nActivityID = new LINQ<any>(_lstDuration).FirstOrDefault()?.nActivityID ?? 0;
            let nYear = form.getValues("nYearID_WorkPlan") ? Convert.StringToInt(form.getValues("nYearID_WorkPlan")) : 0;
            let _nWeightAll = 0;

            //#region Weight แบบทุกกิจกรรม
            let clone = [...lstProjectWorkPlan];
            let lstData = [].concat(...clone.map(m => m.lstProjectPlanActivity)).filter(f => f.nActivityID !== nActivityID);
            _nWeightAll = lstData.map(m => parseInt(m.nWeightActivityAll) || 0).reduce((a, b) => a + b, 0);
            //#endregion           

            _lstDuration.forEach(iDuration => {
                let dDateStart = moment(formDuration.getValues(`sStartMonth_${iDuration.nID}`));
                let dDateEnd = moment(formDuration.getValues(`sEndMonth_${iDuration.nID}`));
                let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(dDateStart.startOf('month').year(nYear)) : null;
                let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(dDateEnd.endOf('month').year(nYear)) : null;
                // let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "MMMM YYYY", "th");
                // let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "MMMM YYYY", "th");
                let nMonthStart = parseInt(dDateStart.format("M"));
                let nMonthEnd = parseInt(dDateEnd.format("M"));
                let nWeight = parseInt(formDuration.getValues(`nWeight_${iDuration.nID}`));
                // let nBudget = parseFloat(formDuration.getValues(`nBudget_${iDuration.nID}`));

                iDuration.sTargetUnit = formWorkPlan.getValues("sTargetUnit");
                iDuration.dStart = dDateStart;
                iDuration.nDateStart = nUnixTimeStart;
                iDuration.dEnd = dDateEnd;
                iDuration.nDateEnd = nUnixTimeEnd;
                iDuration.nMonthStart = nMonthStart;
                iDuration.nMonthEnd = nMonthEnd;
                iDuration.nWeight = nWeight;
                // iDuration.nBudget = nBudget;

                //#region ค่าแต่ล่ะช่วงเดือน
                // let nDiff = moment(formDuration.getValues(`sEndMonth_${iDuration.nID}`)).diff(moment(formDuration.getValues(`sStartMonth_${iDuration.nID}`)), "month");
                let nDiff = nMonthEnd - nMonthStart;
                let _nWeight = 0;
                if (!isNaN(nDiff) && nWeight) {
                    _nWeight = nWeight * (nDiff + 1);
                }
                _nWeightAll += _nWeight;
                //#endregion
            });

            //#region ตรวจสอบ ค่าน้ำหนัก ของทุกปี ว่าเกิน 100 ไหม
            let _lstSummaryYear = lstSummaryYear.filter(f => f.nYear !== nYear);
            let sWarning = null;
            if (_lstSummaryYear.length > 0 && arrDataYearID.length > 1) {
                let nWeightAllYear = new LINQ<any>(_lstSummaryYear).Sum(s => s.nWeightAll);
                let _nWeightAllYear = _nWeightAll + nWeightAllYear;
                if (_nWeightAll > 100) {
                    sWarning = "ไม่สามารถเพิ่มข้อมูลได้ กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนเกิน ค่าน้ำหนัก (ร้อยละ).";
                }
                else if (_nWeightAllYear > 100) //ทุกปีรวมกันเกิน 100
                {
                    sWarning = "ไม่สามารถเพิ่มข้อมูลได้ กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนในทุกปีเกิน ค่าน้ำหนัก (ร้อยละ).";
                }
            }
            else if (_nWeightAll > 100) {
                sWarning = "ไม่สามารถเพิ่มข้อมูลได้ กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนเกิน ค่าน้ำหนัก (ร้อยละ).";
            }
            if (sWarning !== null) return DialogFn.Warning(sWarning);
            //#endregion

            (lstProjectWorkPlan || []).filter(w => w.nProjectPlanID === nProjectPlanID).forEach(iPlan => {
                (iPlan.lstProjectPlanActivity || []).filter(w => w.nActivityID === nActivityID).forEach(iActivity => {
                    iActivity.sTargetUnit = formWorkPlan.getValues("sTargetUnit");
                    iActivity.lstWorkPlanDate = _lstDuration;
                    let arrSumnWeightAll = [];
                    iActivity.nM1 = _lstDuration.find(f => f.nMonthStart <= 1 && f.nMonthEnd >= 1)?.nWeight ?? null;
                    iActivity.nM2 = _lstDuration.find(f => f.nMonthStart <= 2 && f.nMonthEnd >= 2)?.nWeight ?? null;
                    iActivity.nM3 = _lstDuration.find(f => f.nMonthStart <= 3 && f.nMonthEnd >= 3)?.nWeight ?? null;
                    iActivity.nM4 = _lstDuration.find(f => f.nMonthStart <= 4 && f.nMonthEnd >= 4)?.nWeight ?? null;
                    iActivity.nM5 = _lstDuration.find(f => f.nMonthStart <= 5 && f.nMonthEnd >= 5)?.nWeight ?? null;
                    iActivity.nM6 = _lstDuration.find(f => f.nMonthStart <= 6 && f.nMonthEnd >= 6)?.nWeight ?? null;
                    iActivity.nM7 = _lstDuration.find(f => f.nMonthStart <= 7 && f.nMonthEnd >= 7)?.nWeight ?? null;
                    iActivity.nM8 = _lstDuration.find(f => f.nMonthStart <= 8 && f.nMonthEnd >= 8)?.nWeight ?? null;
                    iActivity.nM9 = _lstDuration.find(f => f.nMonthStart <= 9 && f.nMonthEnd >= 9)?.nWeight ?? null;
                    iActivity.nM10 = _lstDuration.find(f => f.nMonthStart <= 10 && f.nMonthEnd >= 10)?.nWeight ?? null;
                    iActivity.nM11 = _lstDuration.find(f => f.nMonthStart <= 11 && f.nMonthEnd >= 11)?.nWeight ?? null;
                    iActivity.nM12 = _lstDuration.find(f => f.nMonthStart <= 12 && f.nMonthEnd >= 12)?.nWeight ?? null;
                    if (iActivity.nM1 !== null) arrSumnWeightAll.push(iActivity.nM1); //parseFloatCheckValue(iActivity.nM1)
                    if (iActivity.nM2 !== null) arrSumnWeightAll.push(iActivity.nM2);
                    if (iActivity.nM3 !== null) arrSumnWeightAll.push(iActivity.nM3);
                    if (iActivity.nM4 !== null) arrSumnWeightAll.push(iActivity.nM4);
                    if (iActivity.nM5 !== null) arrSumnWeightAll.push(iActivity.nM5);
                    if (iActivity.nM6 !== null) arrSumnWeightAll.push(iActivity.nM6);
                    if (iActivity.nM7 !== null) arrSumnWeightAll.push(iActivity.nM7);
                    if (iActivity.nM8 !== null) arrSumnWeightAll.push(iActivity.nM8);
                    if (iActivity.nM9 !== null) arrSumnWeightAll.push(iActivity.nM9);
                    if (iActivity.nM10 !== null) arrSumnWeightAll.push(iActivity.nM10);
                    if (iActivity.nM11 !== null) arrSumnWeightAll.push(iActivity.nM11);
                    if (iActivity.nM12 !== null) arrSumnWeightAll.push(iActivity.nM12);

                    // iActivity.nWeightActivityAll = SetValueSum(arrSumnWeightAll); //parseFloatCheckValue(SetValueSum(arrSumnWeightAll)); //new LINQ<any>(_lstDuration).Sum(s=> s.nWeight);   
                    // iActivity.isUpDate = (_lstDuration || []).length > 0 ? true : false;
                    //เปลี่ยน เงื่อนไข ค่ารวมทั้งกิจกรรม ทุกปี
                    iActivity.nWeightActivityAll = SetValueSum(arrSumnWeightAll) ?? (iActivity.nWeightActivityYearAll != null ? 0 : null); //ค่ารวมทั้งกิจกรรม
                    iActivity.isUpDate = (iActivity.nWeightActivityYearAll !== null || (_lstDuration || []).length > 0) ? true : false;
                });
                iPlan.nWeightAll = new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s => s.nWeightActivityAll);

                // iPlan.nM1All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM1) || 0).reduce((a, b) => a + b, 0); //new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s=> s.nM1); 
                // iPlan.nM2All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM2) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM3All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM3) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM4All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM4) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM5All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM5) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM6All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM6) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM7All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM7) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM8All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM8) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM9All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM9) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM10All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM10) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM11All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM11) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM12All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM12) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nQuarter1All = parseFloat((iPlan.nM1All ?? 0) + (iPlan.nM2All ?? 0) + (iPlan.nM3All ?? 0));
                // iPlan.nQuarter2All = parseFloat((iPlan.nM4All ?? 0) + (iPlan.nM5All ?? 0) + (iPlan.nM6All ?? 0));
                // iPlan.nQuarter3All = parseFloat((iPlan.nM7All ?? 0) + (iPlan.nM8All ?? 0) + (iPlan.nM9All ?? 0));
                // iPlan.nQuarter4All = parseFloat((iPlan.nM10All ?? 0) + (iPlan.nM11All ?? 0) + (iPlan.nM12All ?? 0));

                iPlan.nM1All = iPlan.lstProjectPlanActivity.filter(f => f.nM1 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM1 !== null).Sum(s => s.nM1) : null;
                iPlan.nM2All = iPlan.lstProjectPlanActivity.filter(f => f.nM2 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM2 !== null).Sum(s => s.nM2) : null;
                iPlan.nM3All = iPlan.lstProjectPlanActivity.filter(f => f.nM3 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM3 !== null).Sum(s => s.nM3) : null;
                iPlan.nM4All = iPlan.lstProjectPlanActivity.filter(f => f.nM4 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM4 !== null).Sum(s => s.nM4) : null;
                iPlan.nM5All = iPlan.lstProjectPlanActivity.filter(f => f.nM5 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM5 !== null).Sum(s => s.nM5) : null;
                iPlan.nM6All = iPlan.lstProjectPlanActivity.filter(f => f.nM6 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM6 !== null).Sum(s => s.nM6) : null;
                iPlan.nM7All = iPlan.lstProjectPlanActivity.filter(f => f.nM7 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM7 !== null).Sum(s => s.nM7) : null;
                iPlan.nM8All = iPlan.lstProjectPlanActivity.filter(f => f.nM8 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM8 !== null).Sum(s => s.nM8) : null;
                iPlan.nM9All = iPlan.lstProjectPlanActivity.filter(f => f.nM9 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM9 !== null).Sum(s => s.nM9) : null;
                iPlan.nM10All = iPlan.lstProjectPlanActivity.filter(f => f.nM10 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM10 !== null).Sum(s => s.nM10) : null;
                iPlan.nM11All = iPlan.lstProjectPlanActivity.filter(f => f.nM11 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM11 !== null).Sum(s => s.nM11) : null;
                iPlan.nM12All = iPlan.lstProjectPlanActivity.filter(f => f.nM12 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM12 !== null).Sum(s => s.nM12) : null;
                let nQ1 = null;
                let nQ2 = null;
                let nQ3 = null;
                let nQ4 = null;
                if (iPlan.nM1All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM1All;
                if (iPlan.nM2All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM2All;
                if (iPlan.nM3All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM3All;
                if (iPlan.nM4All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM4All;
                if (iPlan.nM5All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM5All;
                if (iPlan.nM6All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM6All;
                if (iPlan.nM7All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM7All;
                if (iPlan.nM8All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM8All;
                if (iPlan.nM9All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM9All;
                if (iPlan.nM10All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM10All;
                if (iPlan.nM11All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM11All;
                if (iPlan.nM12All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM12All;
                iPlan.nQuarter1All = nQ1;
                iPlan.nQuarter2All = nQ2;
                iPlan.nQuarter3All = nQ3;
                iPlan.nQuarter4All = nQ4;

                let nCountPlanActivity = new LINQ<any>(iPlan.lstProjectPlanActivity).Where(s => s.isUpDate === true).Count();
                iPlan.isSuccess = (iPlan.lstProjectPlanActivity || []).length === nCountPlanActivity ? true : false;
            });
            onClearField();
        }
    };

    const onClearField = () => {
        setnProjectPlanID(null);
        setsActivityName(null);
        setarrDuration([]);
        Object.keys(formWorkPlan.getValues()).forEach((key) => {
            formWorkPlan.setValue(key, null);
            formWorkPlan.clearErrors(key);
        });
        onClearDuration();
    };
    //#endregion

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        let nWorkPlanAll = lstProjectWorkPlan.length;
        let nWorkPlan = lstProjectWorkPlan.filter(f => f.isSuccess === true).length;
        if (nWorkPlanAll !== nWorkPlan && nModeID === EnumSaveModeProject.Submit) {
            return DialogFn.Warning("กรุณาเพิ่มข้อมูล แผนงาน/กิจกรรม ให้ครบถ้วน");
        }

        let ObjData = form.getValues();
        let nYear = Convert.StringToInt(ObjData.nYearID_WorkPlan);
        let isComplete = null;
        if (nStatusID !== EnumProjectStatusID.nStatusID_0) {
            //กรณีที่เลย ส่งนำเสนอมาและแก้ไข และข้อมูลยังไม่ถูกต้อง ให้ไปอัพเดตให้เป็น บันทึกร่าง และถ้า กดอีกที ข้อมูลถูกให้เป้น บันทึกพร้อมส่ง <<< isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง"
            //จะต้องเอาทุกปีมาเช็ค ว่าเท่ากับ 100% ไหม ต้อง 100% เท่านั้น รวมกันทุกปี
            isComplete = nWeight === 100; // isComplete > False = บันทึกร่าง | True = บันทึกพร้อมส่ง | Null = ไม่ต้องไปบันทึกเพิ่ม
        }

        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPlanID: EnumProjectPlan.WorkPlan,
            isFastTrack: isFastTrack,

            nYear: nYear,
            ObjDataAll: ObjDataAll,
            lstProjectWorkPlan: lstProjectWorkPlan,

            sLocation: location.pathname,
            isComplete: isComplete, //isComplete > False = บันทึกร่าง | True = บันทึกพร้อมส่ง | Null = ไม่ต้องไปบันทึกเพิ่ม
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
            ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent)
            : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
                DialogFn.BlockUI();
                AxiosFn.Post(ApiProject.SaveProjectRequestWorkPlan, param, (result) => {
                    DialogFn.UnBlockUI();
                    if (result.nStatusCode === APIStatusCode.Success) {
                        DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                            setnProjectID(result.objResult?.nProjectID);
                            // setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true); //แบบทำงานปกติก่อน ส่งนำเสนอ
                            setisComplete(isComplete ?? (nModeID === EnumSaveModeProject.Draft ? false : true)); //หลัง ส่งนำเสนอ //isComplete > False = บันทึกร่าง | True = บันทึกพร้อมส่ง | Null = ไม่ต้องไปบันทึกเพิ่ม
                            setisChangePanel6(true);
                            setisSubmit(isSubmit === true ? false : true);
                            if (isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                        });
                    } else {
                        DialogFn.Warning(result.sMessage);
                    }
                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            });
    }

    const CheckSubmitProjectChangeStatus = () => { //ไว้เช็คตอนที่มีการเปลี่ยนแปลก Panel 7 | Panel 9 จะมีผลต่อนี้
        let nWorkPlanAll = lstProjectWorkPlan.length;
        let nWorkPlan = lstProjectWorkPlan.filter(f => f.isSuccess === true).length;

        let isWarning = false;
        let sWarning = "";
        if (nWorkPlanAll !== nWorkPlan) {
            isWarning = true;
            sWarning += "- กท 2/1 (แผนปฎิบัติงาน) : กรุณาเพิ่มข้อมูล แผนงาน/กิจกรรม ให้ครบถ้วน. <br/>";
        }

        //จะต้องเอาทุกปีมาเช็ค ว่าเท่ากับ 100% ไหม ต้อง 100% เท่านั้น รวมกันทุกปี
        // let nYear = form.getValues("nYearID_WorkPlan") ? Convert.StringToInt(form.getValues("nYearID_WorkPlan")) : 0;
        // let nWeightAllYear = new LINQ<any>(lstSummaryYear).Where(w=> w.nYear !== nYear).Sum(s=> s.nWeightAll);
        // let _nWeightAllYear = nWeight + nWeightAllYear;  

        if (nWeight > 100) { //(_nWeightAllYear > 100)
            isWarning = true;
            sWarning += "- กท 2/1 (แผนปฎิบัติงาน) : กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนในทุกปีเกิน ค่าน้ำหนัก (ร้อยละ).<br/>";
        }
        else if (nWeight < 100) { //(_nWeightAllYear < 100)
            isWarning = true;
            sWarning += "- กท 2/1 (แผนปฎิบัติงาน) : กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนในทุกปีน้อยกว่า ค่าน้ำหนัก (ร้อยละ).<br/>";
        }

        setObjCheckSubmitVersion({
            isPanel9: ObjCheckSubmitVersion?.isPanel9,
            sWarningPanel9: ObjCheckSubmitVersion?.sWarningPanel9,
            isWorkPlan: true,
            // sWarningWorkPlan: (nWorkPlanAll !== nWorkPlan ? "- กท 2/1 (แผนปฎิบัติงาน) : กรุณาเพิ่มข้อมูล แผนงาน/กิจกรรม ให้ครบถ้วน. <br/>" : null),
            sWarningWorkPlan: (isWarning === true ? sWarning : null),
            isSpendingPlan: ObjCheckSubmitVersion?.isSpendingPlan,
            sWarningSpendingPlan: ObjCheckSubmitVersion?.sWarningSpendingPlan,
        }); //Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
    }

    const handleExportExcel = () => {
        let nYear = Convert.StringToIntOrNull(form.getValues("nYearID_WorkPlan"));
        //Plan 2/1 Work Plan && Plan 2/2 Spending Plan
        let sFileName = `แผนปฎิบัติงานประจำปี_${nYear + 543}.xlsx`;

        let ObjData = {
            nProjectID: nProjectID,
            nYear: nYear,
            nProjectSummary: nProjectSummary ?? 0,
            lstnYear: DefaultArrayEmpty((arrDataYearID || []).map(m => Convert.StringToInt(m.value))),
            nProjectVersionID: (nProjectVersionID === 0 ? null : nProjectVersionID),

            sProjectName: ObjDataAll?.sProjectName ?? " - ",
            sUnitOwnerName: ObjDataAll?.sUnitOwnerName ?? " - ",
            // sAreaName: ObjDataAll?.sAreaName.replaceAll("<br/>", "\n") ?? " - ",
            sAreaName: ObjDataAll?.sAreaName.replaceAll("<br/>", ", ") ?? " - ",
            sPeriod: ObjDataAll?.sPeriod ?? " - ",
            sMoney: ObjDataAll?.nMoney != null ? (formatNumber(ObjDataAll?.nMoney, 2) ?? " - ") + " บาท (" + (ObjDataAll?.sMoneyThaiBaht ?? "แสดงวงเงินตัวอักษรภาษาไทย") + ")" : " - ",
        };
        AxiosFn.DowloadFileBlob(ApiProject.ExportExcelWorkPlan, ObjData, sFileName, (result) => {}, (err) => {}, DialogFn.BlockUI(), DialogFn.UnBlockUI());
    }

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <FormProvider {...form}>
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">แผนปฎิบัติงานประจำปี</Typography>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            {nProjectID !== 0 ?
                                <SelectItem
                                    id="nYearID_WorkPlan"
                                    name="nYearID_WorkPlan"
                                    options={arrDataYearID}
                                    label={""}
                                    required={true}
                                    IsClearable={true}
                                // onChange={handleGetFormProjectID}
                                />
                                :
                                <Typography variant='body1'>{" - "}</Typography>
                            }
                        </Grid>
                        {nProjectID !== 0 &&
                            <Grid item xs={12} md={2} justifyContent={"center"} sx={{ display: "flex" }}>
                                <BtnExportExcel id={"expReportWorkPlan"} tooltiptxt='Export to Excel File' onClick={() => { handleExportExcel() }} />
                            </Grid>
                        }
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">ชื่องาน/โครงการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography variant='body1'>{ObjDataAll?.sProjectName ?? " - "}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">เจ้าของโครงการ/ผู้มีสิทธิ์</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography variant='body1'>{ObjDataAll?.sUnitOwnerName ?? " - "}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">พื้นที่ดำเนินงาน</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography variant='body1'>{ParseHtml(ObjDataAll?.sAreaName ?? " - ")}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">ระยะเวลาดำเนินโครงการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography variant='body1'>{ObjDataAll?.sPeriod ?? " - "}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">วงเงิน</Typography>
                        </Grid>
                        {ObjDataAll?.nMoney != null ?
                            <Grid item xs={12} md={9} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1'>{formatNumber(ObjDataAll?.nMoney, 2) ?? " - "}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">บาท</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1'>{"(" + (ObjDataAll?.sMoneyThaiBaht ?? "แสดงวงเงินตัวอักษรภาษาไทย") + ")"}</Typography>
                                </Grid>
                            </Grid>
                            :
                            <Grid item xs={12} md={9}>
                                <Typography variant='body1'>{" - "}</Typography>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                    <AccordionPanel
                        header={"แผนการปฎิบัติงาน"}
                        isExpanded={false}
                        // SubHeader={}
                        color="white"
                        bgColor="rgb(102,151,245)"
                        background="#5598fc"
                        expandIconColor="white"
                        borderColor="1px solid #5598fc"
                        borderRadius="18px !important"
                        boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                        boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        SubHeaderStatus={
                            (isComplete !== null &&
                                <Chip
                                    size="small"
                                    label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                                    style={{
                                        color: "white",
                                        backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                                        fontSize: "14px"
                                    }}
                                />
                            )
                        }
                    >
                        <Grid id='myDivWorkPlan' item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                            <FormProvider {...formWorkPlan}>
                                {nProjectPlanID !== null &&
                                    <Grid item xs={12} md={12} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <HeaderInput text={"ชื่อกิจกรรม :  " + sActivityName} />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextBoxItem
                                                id={"sTargetUnit"}
                                                name={"sTargetUnit"}
                                                type={"text"}
                                                label={"เป้าหมายปริมาณงาน (หน่วยนับ)"}
                                                // endAdornment={"หน่วยนับ"}
                                                required={true}
                                                maxLength={50}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="flex-start" alignItems="flex-start" style={{ paddingBottom: '1%', }}>
                                            {/* <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                                <Divider textAlign="left">ระยะเวลาปฎิบัติงาน</Divider>
                                            </Grid>  */}
                                            <Grid item xs={12} md={2}>
                                                <HeaderInput text={"ระยะเวลาปฎิบัติงาน"} />
                                            </Grid>
                                            <Grid item xs={12} md={10}>
                                                <WorkPlanDuration
                                                    nYear={Convert.StringToInt(form.watch("nYearID_WorkPlan"))}
                                                    formDuration={formDuration}
                                                    onAddDuration={onAddDuration}
                                                    onDeleteDuration={onDeleteDuration}
                                                    arrDuration={arrDuration}
                                                    dataRowProject={lstProjectWorkPlan}
                                                    // isPermission={isPermission}
                                                    isPermission={((isPermission && isModeSecretary !== true) ? isPermission : isEditSecretary ?? false)}
                                                    dStart={_dStart}
                                                    dEnd={_dEnd}
                                                    trigger={trigger}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                (arrDuration.filter((f) => f.dStart === null).length > 0 ?
                                                    <Grid item>
                                                        <BtnAdd id={"btnAdd_WorkPlan"} txt={"เพิ่มข้อมูล"} IsDisabled={!isPermission || isEditSecretary === false} onClick={formWorkPlan.handleSubmit((e) => onAddWorkPlan(), (err) => console.log("err", err))} />
                                                    </Grid>
                                                    :
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_WorkPlan"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formWorkPlan.handleSubmit((e) => onAddWorkPlan(), (err) => console.log("err", err))} />
                                                    </Grid>
                                                )
                                            }
                                            <Grid item>
                                                <BtnCancel id={"btnCancel_WorkPlan"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectPlanID(null); }} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                    <CallTableWorkPlan />
                                </Grid>
                            </FormProvider>
                        </Grid>
                    </AccordionPanel>
                </Grid>
                {nProjectID === 0 || (nStatusID === EnumProjectStatusID.nStatusID_11 && nLogChangeID === null) ?
                    <></>
                    :
                    (isPermission === true &&
                        (isModeSecretary !== true ?
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                    <Grid item>
                                        <BtnDraft id={"btnDraft_WorkPlan"} IsDisabled={isError} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                    </Grid>
                                }
                                <Grid item>
                                    {/* IsDisabled={isError || !isWeightBtn} ปิดไว้เพราะจะเกิดกรณีที่ เลขาแก้ไข เขาต้องบันทึกทีล่ะปีได้ และการบันทึกตรงนี้ถ้ากรณีที่ มากกว่า 1 ปี จะต้องมองด้วยว่าครบ 100 ถ้าเลยการทำงานของ ส่งนำเสนอมาแล้ว จะไม่เช็คและอัพเดต ให้เป็นบันทึกร่าง เท่านั้น  */}
                                    <BtnSendRequest id={"btnSend_WorkPlan"} IsDisabled={(nStatusID === EnumProjectStatusID.nStatusID_0 ? (isError || !isWeightBtn) : isError)} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit) }} />
                                </Grid>
                            </Grid>
                            :
                            (isModeSecretary === true ?
                                <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                    {isEditSecretary === false ?
                                        <Grid item>
                                            <BtnEdit id={"btnEdit_WorkPlan"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivWorkPlan").scrollIntoView({ behavior: "smooth" }); }} />
                                        </Grid>
                                        :
                                        <>
                                            <Grid item>
                                                <BtnCancel id={"btnCancel_WorkPlan"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); onClearField(); handleGetFormProjectID(form.watch("nYearID_WorkPlan")); }} />
                                            </Grid>
                                            <Grid item>
                                                {/* IsDisabled={isError || !isWeightBtn} ปิดไว้เพราะจะเกิดกรณีที่ เลขาแก้ไข เขาต้องบันทึกทีล่ะปีได้ และการบันทึกตรงนี้ถ้ากรณีที่ มากกว่า 1 ปี จะต้องมองด้วยว่าครบ 100 ถ้าเลยการทำงานของ ส่งนำเสนอมาแล้ว จะไม่เช็คและอัพเดต ให้เป็นบันทึกร่าง เท่านั้น  */}
                                                <BtnSendRequest id={"btnSend_WorkPlan"} IsDisabled={isError} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                                : <></>
                            )
                        )
                    )
                }
                <Grid item style={{ display: 'none' }}>
                    <BtnSendRequest id={"btnCheck_WorkPlan_ChangeStatus"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { CheckSubmitProjectChangeStatus(); }} />
                </Grid>
            </FormProvider>
            <ModalPreview />
        </Grid>
    )
}
export default RequestWorkPlan;
